import { Icon, Tooltip, TooltipProps } from "@chakra-ui/react";
import { MdAutoAwesome } from "react-icons/md";

type Props = Omit<TooltipProps, "children">;

export default function AutoTooltipIcon(props: Props) {
  return (
    <Tooltip hasArrow openDelay={300} {...props}>
      <span>
        <Icon
          as={MdAutoAwesome}
          fontSize=".9em"
          ml=".25em"
          my="-.1em"
          verticalAlign="baseline"
          color="magenta.dark"
          opacity={0.5}
          sx={{ 'tr[aria-selected="true"] &': { color: "inherit" } }}
        />
      </span>
    </Tooltip>
  );
}
